import React, { useContext } from 'react';
import SubHeader from '../SubHeader/SubHeader';
import { AppContext } from 'App.context';
import useGuestDetailsHook from './GuestDetails.hook';
import GuestDetailsForm from './GuestDetailsForm/GuestDetailsForm';

export default function GuestDetails({ onNext }) {
  const {
    appActions: { getSelectedHotel },
  } = useContext(AppContext);
  const { state, actions } = useGuestDetailsHook();
  return (
    <>
      <SubHeader
        hotelName={getSelectedHotel()?.name}
        showNext={state.isValid}
        onNext={() => {
          actions.saveGuestDetails();
          onNext();
        }}
      />
      {state.initialized && (
        <GuestDetailsForm onFormChange={actions.onFormChange} initialValues={state.formData} />
      )}
    </>
  );
}
